import { getNovSchema } from "utility";

export function generateAcceleratedReaderSearchUrl(profileData, isbnToExclude, bookLevel, interestLevel, custLinks) {
	const apiEndpoint = `${getNovSchema()}${window.novSelect.baseUrl}/api/acceleratedreader/ByInterestAndBookLevel?`;
	const customerInfo = profileData && `profile=${profileData.Profile}&password=${profileData.Password}`;
	const searchTerms = `&bookLevel=${bookLevel}&interestLevel=`;
	const encodedInterestLevel = encodeURIComponent(interestLevel);
	const searchTermsToExclude = `&isbnToExclude=${isbnToExclude}`;
	const customLinkReplacements = `${custLinks}`;

	// encoded interest level must be inserted outside of encodeURI() to avoid double encoding
	return encodeURI(`${apiEndpoint}${customerInfo}${searchTerms}`) + `${encodedInterestLevel}` + encodeURI(`${searchTermsToExclude}${customLinkReplacements}`);
}



// WEBPACK FOOTER //
// ./src/react/containers/acceleratedReader/arSearchUrlBuilder.js